var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("GetFormField")
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("get.Stock.MovementNumber")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.MovementNumber))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-calendar-alt" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("get.Stock.DocumentDate")) + ":")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dateConvertFromTimezone(_vm.rowData.MovementDate)
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-clock" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("get.Stock.MovementTime")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.MovementTime))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.description1")) + ":")]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.Customer"), active: "" }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ToWarehouse,
                                "object",
                                "get.Stock.ToWarehouseId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.MovementType,
                                "object",
                                "get.Stock.MovementTypeId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ToStatus,
                                "object",
                                "get.Stock.ToStatusId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Representative,
                                "object",
                                "get.Stock.RepresentativeId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-12 asc__showPage-card" },
                      [
                        _vm.rowData.StockAdjustmentItems &&
                        _vm.rowData.StockAdjustmentItems.length > 0
                          ? _c("NextExportDetail", {
                              attrs: {
                                url:
                                  "VisionNextStockManagement/api/StockAdjustment/ExcelExportItems",
                                "record-id": _vm.rowData.RecordId,
                                "record-key": "stockAdjustmentId",
                                "file-name": _vm.$t("get.RMA.Items")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-table-simple",
                          { attrs: { responsive: "", hover: "", small: "" } },
                          [
                            _c(
                              "b-thead",
                              [
                                _c("b-th", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "insert.BranchStockTransfer.ItemCode"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-th", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "insert.BranchStockTransfer.Items"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-th", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "insert.BranchStockTransfer.ToWhStockQuantity"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-th", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "insert.BranchStockTransfer.Unit"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-th", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "insert.BranchStockTransfer.PlanQuantity"
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tbody",
                              _vm._l(_vm.rowData.StockAdjustmentItems, function(
                                r,
                                i
                              ) {
                                return _c(
                                  "b-tr",
                                  { key: i },
                                  [
                                    _c("b-td", [
                                      _vm._v(_vm._s(r.Item && r.Item.Code))
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(_vm._s(r.Item && r.Item.Label))
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(_vm._s(r.ToWhStockQuantity))
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(_vm._s(r.Unit && r.Unit.Label))
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(r.Quantity))])
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c854ef14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c854ef14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockAdjustment/get.vue
// module id = null
// module chunks = 